import React from 'react';
import { useGlobalContext } from '@honeycomb/data';
import { InformationIcon, Notification, Anchor } from '@honeycomb/ui-core';
import { hotelSRPRouting, homeRouting } from '@honeycomb/routing';
import reactStringReplace from 'react-string-replace';
export function SingleFlightResultNotification() {
    const { resourceStrings: { FLIGHTSEARCHSINGLERESULTMESSAGE, SINGLEFLIGHTMESSAGERETURNTORESULTS, STARTNEWSEARCH }, } = useGlobalContext();
    const parsedText = () => {
        const replacedText = reactStringReplace(reactStringReplace(FLIGHTSEARCHSINGLERESULTMESSAGE, '{0}', () => (React.createElement(Anchor, { underline: "always", key: "single-flight-message", onClick: hotelSRPRouting }, SINGLEFLIGHTMESSAGERETURNTORESULTS))), '{1}', () => (React.createElement(Anchor, { underline: "always", key: "start-new-search", onClick: homeRouting }, STARTNEWSEARCH)));
        return replacedText;
    };
    return (React.createElement(Notification, { color: "info", icon: React.createElement(InformationIcon, null) },
        React.createElement("p", null, parsedText())));
}
